export const DealersType = {
  setDealers: "[Dealers] setDealers",
  setDealer: "[Dealers] setDealer",
};
